// third-party
import { Trans } from 'react-i18next';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';
import { OverrideIcon } from 'types';

// constant
const icons = {
    IconDashboard,
    IconDeviceAnalytics
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

interface SysMenuProps {
    id: string;
    title: React.ReactNode | string;
    type: string;
    children: {
        id: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
    }[];
}

const setting: SysMenuProps = {
    id: 'setting',
    title: <Trans i18nKey="Setting" id="Setting" />,
    type: 'group',
    children: [
        {
            id: 'user-roles',
            title: <Trans i18nKey="User Roles" id="User Roles" />,
            type: 'item',
            url: '/user-roles',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
    ]
};

export default setting;
